"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BoumRight_value, _BoumRight_bit, _BoumRight_str, _enDeCoder_enums, _enDeCoder_values;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoumRightEnDeCoder = exports.BoumRight = void 0;
const claims_1 = require("./claims");
class BoumRight {
    constructor(value, bit, str) {
        _BoumRight_value.set(this, void 0);
        _BoumRight_bit.set(this, void 0);
        _BoumRight_str.set(this, void 0);
        __classPrivateFieldSet(this, _BoumRight_value, value, "f");
        __classPrivateFieldSet(this, _BoumRight_bit, bit, "f");
        __classPrivateFieldSet(this, _BoumRight_str, str, "f");
    }
    value() {
        return __classPrivateFieldGet(this, _BoumRight_value, "f");
    }
    bit() {
        return __classPrivateFieldGet(this, _BoumRight_bit, "f");
    }
    str() {
        return __classPrivateFieldGet(this, _BoumRight_str, "f");
    }
    toString() {
        return __classPrivateFieldGet(this, _BoumRight_str, "f");
    }
    toJSON() {
        return this.toString();
    }
}
exports.BoumRight = BoumRight;
_BoumRight_value = new WeakMap(), _BoumRight_bit = new WeakMap(), _BoumRight_str = new WeakMap();
// Enum contains 213 values. In bytes it 4771 bytes
// Right to create, read, update and delete records in the "Accounting Area"
BoumRight.ACCOUNTING_RECORDS_CRUD = new BoumRight(3151874999, 2, "ACCOUNTING_RECORDS_CRUD");
// Retrieve AD alerts and perform assignments
BoumRight.AD_FLEET_CONTROL_ALERT = new BoumRight(3151875170, 173, "AD_FLEET_CONTROL_ALERT");
// Access to read the audit log of AD vehicles
BoumRight.AD_FLEET_CONTROL_AUDIT_LOG_R = new BoumRight(3151875000, 3, "AD_FLEET_CONTROL_AUDIT_LOG_R");
// Access to cabin safety check of AD vehicles
BoumRight.AD_FLEET_CONTROL_CABIN_SAFETY_CHECK = new BoumRight(3151875001, 4, "AD_FLEET_CONTROL_CABIN_SAFETY_CHECK");
// Access to cabin video stream of AD vehicles
BoumRight.AD_FLEET_CONTROL_CABIN_VIDEO_STREAM = new BoumRight(3151875002, 5, "AD_FLEET_CONTROL_CABIN_VIDEO_STREAM");
// Request door acuations of AD vehicles
BoumRight.AD_FLEET_CONTROL_DOOR_ACTUATION = new BoumRight(3151875003, 6, "AD_FLEET_CONTROL_DOOR_ACTUATION");
// Accept and initiate outgoing phone calls to AD vehicles
BoumRight.AD_FLEET_CONTROL_OPERATOR_CONNECT = new BoumRight(3151875004, 7, "AD_FLEET_CONTROL_OPERATOR_CONNECT");
// Right to change pooling status of AD vehicles
BoumRight.AD_FLEET_CONTROL_UPDATE_POOLING_STATUS = new BoumRight(3151875005, 8, "AD_FLEET_CONTROL_UPDATE_POOLING_STATUS");
// Right to perform a service cancellation of AD vehicles
BoumRight.AD_SERVICE_CANCELLATION = new BoumRight(3151875006, 9, "AD_SERVICE_CANCELLATION");
// Access to "Accounting Area"
BoumRight.AREA_ACCOUNTING = new BoumRight(3151875007, 10, "AREA_ACCOUNTING");
// Access to "Ad Configuration Area"
BoumRight.AREA_AD_CONFIGURATION = new BoumRight(3151875008, 11, "AREA_AD_CONFIGURATION");
// Access to "AD Fleet Map Area"
BoumRight.AREA_AD_FLEET_MAP = new BoumRight(3151875009, 12, "AREA_AD_FLEET_MAP");
// Access to "Alerts Area"
BoumRight.AREA_ALERTS = new BoumRight(3151875010, 13, "AREA_ALERTS");
//  Allows the user to view "Capacity Planning" area
BoumRight.AREA_CAPACITY_PLANNING = new BoumRight(3151875171, 174, "AREA_CAPACITY_PLANNING");
// Access to "Coupon Area"
BoumRight.AREA_COUPON = new BoumRight(3151875013, 16, "AREA_COUPON");
// Access to "Customer Area"
BoumRight.AREA_CUSTOMER = new BoumRight(3151875014, 17, "AREA_CUSTOMER");
// Access to "Feature Management" Area
BoumRight.AREA_CUSTOMER_FEATURE_ALLOWLISTING = new BoumRight(3151875015, 18, "AREA_CUSTOMER_FEATURE_ALLOWLISTING");
// Access to "Custom Street Routing Area"
BoumRight.AREA_CUSTOM_STREET_ROUTING = new BoumRight(3151875016, 19, "AREA_CUSTOM_STREET_ROUTING");
// Access to "Dashboard Area"
BoumRight.AREA_DASHBOARD = new BoumRight(3151875017, 20, "AREA_DASHBOARD");
// Access to "Driver Tipping Area"
BoumRight.AREA_DRIVER_TIPPING = new BoumRight(3151875018, 21, "AREA_DRIVER_TIPPING");
// Right to access ds-boss area
BoumRight.AREA_DS_BOSS = new BoumRight(3151875019, 22, "AREA_DS_BOSS");
// Access to "Employee Area"
BoumRight.AREA_EMPLOYEE = new BoumRight(3151875020, 23, "AREA_EMPLOYEE");
// Access to "Fleet Maintanance Area"
BoumRight.AREA_FLEET_MAINTENANCE = new BoumRight(3151875021, 24, "AREA_FLEET_MAINTENANCE");
// Access to "Fleet Map Area"
BoumRight.AREA_FLEET_MAP = new BoumRight(3151875022, 25, "AREA_FLEET_MAP");
// Access to "Hubs Area"
BoumRight.AREA_HUBS = new BoumRight(3151875023, 26, "AREA_HUBS");
// Access to "Pattern Library Area"
BoumRight.AREA_PATTERN_LIBRARY = new BoumRight(3151875024, 27, "AREA_PATTERN_LIBRARY");
// Access to "Pricing Area"
BoumRight.AREA_PRICING = new BoumRight(3151875025, 28, "AREA_PRICING");
// Access to "Service Areas Area"
BoumRight.AREA_SERVICE_AREAS = new BoumRight(3151875026, 29, "AREA_SERVICE_AREAS");
// Access to "Service Hours Area"
BoumRight.AREA_SERVICE_HOURS = new BoumRight(3151875027, 30, "AREA_SERVICE_HOURS");
// Access to "Shifts Area"
BoumRight.AREA_SHIFTS = new BoumRight(3151875028, 31, "AREA_SHIFTS");
// Access to "Stop Network Area"
BoumRight.AREA_STOP_NETWORK = new BoumRight(3151875029, 32, "AREA_STOP_NETWORK");
// Access to "Stop Network Alerts Area"
BoumRight.AREA_STOP_NETWORK_ALERTS = new BoumRight(3151875030, 33, "AREA_STOP_NETWORK_ALERTS");
// Access to "Test Area"
BoumRight.AREA_TEST = new BoumRight(3151875031, 34, "AREA_TEST");
// Access to "Time Management Alerts Area"
BoumRight.AREA_TIME_MANAGEMENT_ALERTS = new BoumRight(3151875032, 35, "AREA_TIME_MANAGEMENT_ALERTS");
// Access to "Trips Area"
BoumRight.AREA_TRIPS = new BoumRight(3151875033, 36, "AREA_TRIPS");
// Access to "Vehicle Area"
BoumRight.AREA_VEHICLE = new BoumRight(3151875034, 37, "AREA_VEHICLE");
// Access to "Vehicle Alerts"
BoumRight.AREA_VEHICLE_ALERTS = new BoumRight(3151875035, 38, "AREA_VEHICLE_ALERTS");
// Access to "Vehicle Group Area"
BoumRight.AREA_VEHICLE_GROUP = new BoumRight(3151875036, 39, "AREA_VEHICLE_GROUP");
// Right to delete a customer
BoumRight.BACKOFFICE_CUSTOMER_D = new BoumRight(3151875039, 42, "BACKOFFICE_CUSTOMER_D");
// Right to read customers
BoumRight.BACKOFFICE_CUSTOMER_R = new BoumRight(3151875040, 43, "BACKOFFICE_CUSTOMER_R");
// Used in Pricing (why?) and Backoffice Backend
BoumRight.BACKOFFICE_CUSTOMER_TRIPS = new BoumRight(3151875041, 44, "BACKOFFICE_CUSTOMER_TRIPS");
// Right to trigger a trip refund
BoumRight.BACKOFFICE_CUSTOMER_TRIPS_TRIGGER_REFUND = new BoumRight(3151875042, 45, "BACKOFFICE_CUSTOMER_TRIPS_TRIGGER_REFUND");
// Right to edit customer data
BoumRight.BACKOFFICE_CUSTOMER_U = new BoumRight(3151875043, 46, "BACKOFFICE_CUSTOMER_U");
// Currently not used
BoumRight.BACKOFFICE_CUSTOMER_WHITELIST = new BoumRight(3151875044, 47, "BACKOFFICE_CUSTOMER_WHITELIST");
// The right to create read update and delete groups
BoumRight.BACKOFFICE_GROUPS_CRUD = new BoumRight(3151875045, 48, "BACKOFFICE_GROUPS_CRUD");
// Access to "Fleet Map Area"
BoumRight.BACKOFFICE_POOLING = new BoumRight(3151875046, 49, "BACKOFFICE_POOLING");
// Allows to create/update/delete Backoffice Statuses
BoumRight.BACKOFFICE_STATUS_CRUD = new BoumRight(3151875047, 50, "BACKOFFICE_STATUS_CRUD");
// Access to read the full trip history of customers
BoumRight.BACKOFFICE_TRIP_HISTORY_R = new BoumRight(3151875048, 51, "BACKOFFICE_TRIP_HISTORY_R");
// Right to read trips
BoumRight.BACKOFFICE_TRIP_R = new BoumRight(3151875049, 52, "BACKOFFICE_TRIP_R");
// Allows to read/create/update/delete Backoffice Updates
BoumRight.BACKOFFICE_UPDATES_CRUD = new BoumRight(3151875050, 53, "BACKOFFICE_UPDATES_CRUD");
// Allows to read all Backoffice Updates independent from the rights filter
BoumRight.BACKOFFICE_UPDATES_R = new BoumRight(3151875051, 54, "BACKOFFICE_UPDATES_R");
// Right to view the history of a Backoffice user
BoumRight.BACKOFFICE_USER_HISTORY_R = new BoumRight(3151875053, 56, "BACKOFFICE_USER_HISTORY_R");
// Right to allow User Manager to blueprint their access (limit list of visible Service Areas and Groups) to Backoffice
BoumRight.BACKOFFICE_USER_MANAGER_BLUEPRINT = new BoumRight(3151875055, 58, "BACKOFFICE_USER_MANAGER_BLUEPRINT");
// Right to read user management right details’
BoumRight.BACKOFFICE_USER_RIGHT_R = new BoumRight(3151875056, 59, "BACKOFFICE_USER_RIGHT_R");
// Right to create a Backoffice user
BoumRight.BACKOFFICE_USER_USER_C = new BoumRight(3151875057, 60, "BACKOFFICE_USER_USER_C");
// Access to perform all actions for backoffice users
BoumRight.BACKOFFICE_USER_USER_CRUD = new BoumRight(3151875175, 178, "BACKOFFICE_USER_USER_CRUD");
// Right to read Backoffice user details’
BoumRight.BACKOFFICE_USER_USER_R = new BoumRight(3151875059, 62, "BACKOFFICE_USER_USER_R");
// Access to "Fleet Map Area"
BoumRight.BACKOFFICE_VEHICLE_MAP = new BoumRight(3151875061, 64, "BACKOFFICE_VEHICLE_MAP");
// Allows the user to create, update and delete Capacity Plannings
BoumRight.CAPACITY_PLANNING_CRUD = new BoumRight(3151875172, 175, "CAPACITY_PLANNING_CRUD");
// Allows the user to read Capacity Plans
BoumRight.CAPACITY_PLANNING_R = new BoumRight(3151875173, 176, "CAPACITY_PLANNING_R");
// Right to create/delete/edit blocked roads
BoumRight.CSR_BLOCKED_ROAD_CRUD = new BoumRight(3151875062, 65, "CSR_BLOCKED_ROAD_CRUD");
// Right to read "Custom Street Routing Area"
BoumRight.CSR_BLOCKED_ROAD_R = new BoumRight(3151875063, 66, "CSR_BLOCKED_ROAD_R");
// Right to create, read, update and delete Custom Street Routing data
BoumRight.CSR_TURN_RESTRICTION_CRUD = new BoumRight(3151875064, 67, "CSR_TURN_RESTRICTION_CRUD");
// Right to read Custom Street Routing data
BoumRight.CSR_TURN_RESTRICTION_R = new BoumRight(3151875065, 68, "CSR_TURN_RESTRICTION_R");
// Right to manage passenger app feature permissions for customers
BoumRight.CUSTOMER_FEATURE_PERMISSIONS_CRUD = new BoumRight(3151875066, 69, "CUSTOMER_FEATURE_PERMISSIONS_CRUD");
// Right to read passenger app feature permissions for customers
BoumRight.CUSTOMER_FEATURE_PERMISSIONS_R = new BoumRight(3151875067, 70, "CUSTOMER_FEATURE_PERMISSIONS_R");
// Right to create customer test credentials
BoumRight.CUSTOMER_TEST_CREDENTIALS_RW = new BoumRight(3151875068, 71, "CUSTOMER_TEST_CREDENTIALS_RW");
// Right to see feature toggles
BoumRight.DEV_USE_FEATURE_TOGGLES = new BoumRight(3151875069, 72, "DEV_USE_FEATURE_TOGGLES");
// Right to use ds-boss
BoumRight.DS_BOSS_CRUD = new BoumRight(3151875070, 73, "DS_BOSS_CRUD");
// Right to read employee address data
BoumRight.EMPLOYEE_ADDRESS_R = new BoumRight(3151875071, 74, "EMPLOYEE_ADDRESS_R");
// Right to change employee supervisor and deputy supervisor
BoumRight.EMPLOYEE_ASSIGN_SUPERVISOR = new BoumRight(3151875072, 75, "EMPLOYEE_ASSIGN_SUPERVISOR");
// Right to delete employees
BoumRight.EMPLOYEE_D = new BoumRight(3151875073, 76, "EMPLOYEE_D");
// Right to read deactivated employee profiles
BoumRight.EMPLOYEE_DEACTIVATED_PROFILES_R = new BoumRight(3151875074, 77, "EMPLOYEE_DEACTIVATED_PROFILES_R");
// Right to see driver emergency contact details
BoumRight.EMPLOYEE_EMERGENCY_CONTACT_R = new BoumRight(3151875075, 78, "EMPLOYEE_EMERGENCY_CONTACT_R");
// Right to read employee driver/p-license data
BoumRight.EMPLOYEE_LICENSES_R = new BoumRight(3151875076, 79, "EMPLOYEE_LICENSES_R");
// Right to create, read, update or delete employee messages
BoumRight.EMPLOYEE_MESSAGES_CRUD = new BoumRight(3151875077, 80, "EMPLOYEE_MESSAGES_CRUD");
// Right to read personal employee messages
BoumRight.EMPLOYEE_MESSAGES_PERSONAL_R = new BoumRight(3151875078, 81, "EMPLOYEE_MESSAGES_PERSONAL_R");
// Right to create, read, update or delete employee notes
BoumRight.EMPLOYEE_NOTES_CRUD = new BoumRight(3151875079, 82, "EMPLOYEE_NOTES_CRUD");
// Right to create, read, update or delete employee personal notes
BoumRight.EMPLOYEE_NOTES_PERSONAL_CRUD = new BoumRight(3151875080, 83, "EMPLOYEE_NOTES_PERSONAL_CRUD");
// Right to see shift performance metrics (number of check-ins, delays, etc.)
BoumRight.EMPLOYEE_PERFORMANCE = new BoumRight(3151875081, 84, "EMPLOYEE_PERFORMANCE");
// Right to see personal data of employees
BoumRight.EMPLOYEE_PERSONAL_DATA_R = new BoumRight(3151875082, 85, "EMPLOYEE_PERSONAL_DATA_R");
// Right to update employee qualification
BoumRight.EMPLOYEE_QUALIFICATION_U = new BoumRight(3151875083, 86, "EMPLOYEE_QUALIFICATION_U");
// Right to read employees
BoumRight.EMPLOYEE_R = new BoumRight(3151875084, 87, "EMPLOYEE_R");
// Right to read shifts
BoumRight.EMPLOYEE_SHIFT = new BoumRight(3151875085, 88, "EMPLOYEE_SHIFT");
// Right to create/update/delete shift activities
BoumRight.EMPLOYEE_SHIFTS_ACTIVITIES_CRUD = new BoumRight(3151875086, 89, "EMPLOYEE_SHIFTS_ACTIVITIES_CRUD");
// Right to view planned shift activities
BoumRight.EMPLOYEE_SHIFTS_ACTIVITIES_R = new BoumRight(3151875087, 90, "EMPLOYEE_SHIFTS_ACTIVITIES_R");
// Right to book shifts using the Backoffice Shift Creation tool
BoumRight.EMPLOYEE_SHIFT_CREATION_TOOL = new BoumRight(3151875088, 91, "EMPLOYEE_SHIFT_CREATION_TOOL");
// Right to see shift demand and supply
BoumRight.EMPLOYEE_SHIFT_DEMAND_SUPPLY_R = new BoumRight(3151875089, 92, "EMPLOYEE_SHIFT_DEMAND_SUPPLY_R");
// Right to use the Hub return feature
BoumRight.EMPLOYEE_SHIFT_HUB_RETURN_PLANNING_CUD = new BoumRight(3151875090, 93, "EMPLOYEE_SHIFT_HUB_RETURN_PLANNING_CUD");
// Right to read short breaks on the shift log
BoumRight.EMPLOYEE_SHIFT_SHORT_BREAKS = new BoumRight(3151875091, 94, "EMPLOYEE_SHIFT_SHORT_BREAKS");
// Right to update shift type (WAV, SDO, or Pluto)
BoumRight.EMPLOYEE_SHIFT_TYPE_U = new BoumRight(3151875092, 95, "EMPLOYEE_SHIFT_TYPE_U");
// Right to create, read, update or delete employee task notifications
BoumRight.EMPLOYEE_TASK_CRUD = new BoumRight(3151875093, 96, "EMPLOYEE_TASK_CRUD");
// Right to read employee task notifications
BoumRight.EMPLOYEE_TASK_R = new BoumRight(3151875094, 97, "EMPLOYEE_TASK_R");
// Right to set a temporary password for employees
BoumRight.EMPLOYEE_TEMPORARY_PASSWORD_U = new BoumRight(3151875095, 98, "EMPLOYEE_TEMPORARY_PASSWORD_U");
// Right to create, read, update or delete employee time management task notifications
BoumRight.EMPLOYEE_TIMES_TASK_CRUD = new BoumRight(3151875096, 99, "EMPLOYEE_TIMES_TASK_CRUD");
// Right to read employee time management task notifications
BoumRight.EMPLOYEE_TIMES_TASK_R = new BoumRight(3151875097, 100, "EMPLOYEE_TIMES_TASK_R");
// Right to update employees
BoumRight.EMPLOYEE_U = new BoumRight(3151875098, 101, "EMPLOYEE_U");
// Right to update employee WAV qualification
BoumRight.EMPLOYEE_WAV_QUALIFICATION_U = new BoumRight(3151875099, 102, "EMPLOYEE_WAV_QUALIFICATION_U");
// Currently not used in BOFE
BoumRight.FLEET_BOX_PC_REPLACEMENT = new BoumRight(3151875101, 104, "FLEET_BOX_PC_REPLACEMENT");
// Right to create, read, update or delete fleet task notifications
BoumRight.FLEET_CONTROL_TASK_CRUD = new BoumRight(3151875102, 105, "FLEET_CONTROL_TASK_CRUD");
// Right to read fleet task notifications
BoumRight.FLEET_CONTROL_TASK_R = new BoumRight(3151875103, 106, "FLEET_CONTROL_TASK_R");
// Right to view vehicle routes
BoumRight.FLEET_CONTROL_VEHICLE_ROUTE = new BoumRight(3151875104, 107, "FLEET_CONTROL_VEHICLE_ROUTE");
// Right to create a damage for a vehicle
BoumRight.FLEET_DAMAGE_REPORT_CRUD = new BoumRight(3151875105, 108, "FLEET_DAMAGE_REPORT_CRUD");
// Right to see damages of a vehicle
BoumRight.FLEET_DAMAGE_REPORT_R = new BoumRight(3151875106, 109, "FLEET_DAMAGE_REPORT_R");
// Right to read a vehicle history
BoumRight.FLEET_HISTORY_R = new BoumRight(3151875107, 110, "FLEET_HISTORY_R");
// Right to create, read, update and delete fleet repair management data
BoumRight.FLEET_REPAIR_MANAGEMENT_CRUD = new BoumRight(3151875108, 111, "FLEET_REPAIR_MANAGEMENT_CRUD");
// Right to read fleet repair management data
BoumRight.FLEET_REPAIR_MANAGEMENT_R = new BoumRight(3151875109, 112, "FLEET_REPAIR_MANAGEMENT_R");
// Right to see the emergency tab at vehicle details
BoumRight.FLEET_VEHICLE_ABORT_SERVICE = new BoumRight(3151875110, 113, "FLEET_VEHICLE_ABORT_SERVICE");
// Right to create/change/delete vehicle alerts
BoumRight.FLEET_VEHICLE_ALERT_CRUD = new BoumRight(3151875111, 114, "FLEET_VEHICLE_ALERT_CRUD");
// Right to read vehicle alerts
BoumRight.FLEET_VEHICLE_ALERT_R = new BoumRight(3151875112, 115, "FLEET_VEHICLE_ALERT_R");
// Right to modify CDIS telemetry box assignment
BoumRight.FLEET_VEHICLE_CDIS_ASSIGNMENT_CUD = new BoumRight(3151875113, 116, "FLEET_VEHICLE_CDIS_ASSIGNMENT_CUD");
// Right to read CDIS telemetry box assignment
BoumRight.FLEET_VEHICLE_CDIS_ASSIGNMENT_R = new BoumRight(3151875114, 117, "FLEET_VEHICLE_CDIS_ASSIGNMENT_R");
// Right to change a vehicle’s general configuration
BoumRight.FLEET_VEHICLE_CONFIGURATION_CRUD = new BoumRight(3151875115, 118, "FLEET_VEHICLE_CONFIGURATION_CRUD");
// Right to create/change/delete a vehicle
BoumRight.FLEET_VEHICLE_CRUD = new BoumRight(3151875116, 119, "FLEET_VEHICLE_CRUD");
// Right to create/change/delete a vehicle group
BoumRight.FLEET_VEHICLE_GROUP_CRUD = new BoumRight(3151875117, 120, "FLEET_VEHICLE_GROUP_CRUD");
// Right to read vehicle groups
BoumRight.FLEET_VEHICLE_GROUP_R = new BoumRight(3151875118, 121, "FLEET_VEHICLE_GROUP_R");
// Right to change a vehicle’s identification configuration
BoumRight.FLEET_VEHICLE_IDENTIFICATION_CRUD = new BoumRight(3151875119, 122, "FLEET_VEHICLE_IDENTIFICATION_CRUD");
// Right to call actions for a vehicle (e.g. open a vehicle)
BoumRight.FLEET_VEHICLE_INTERACTION_C = new BoumRight(3151875120, 123, "FLEET_VEHICLE_INTERACTION_C");
// Right to change and see a vehicle status (e.g. if a vehicle is open)
BoumRight.FLEET_VEHICLE_INTERACTION_CRUD = new BoumRight(3151875121, 124, "FLEET_VEHICLE_INTERACTION_CRUD");
// Right to see a vehicle status (e.g. if a vehicle is open)
BoumRight.FLEET_VEHICLE_INTERACTION_R = new BoumRight(3151875122, 125, "FLEET_VEHICLE_INTERACTION_R");
// Right to create/change/delete vehicle ivc alerts
BoumRight.FLEET_VEHICLE_IVC_ALERT_CRUD = new BoumRight(3151875123, 126, "FLEET_VEHICLE_IVC_ALERT_CRUD");
// Right to read vehicle ivc alerts
BoumRight.FLEET_VEHICLE_IVC_ALERT_R = new BoumRight(3151875124, 127, "FLEET_VEHICLE_IVC_ALERT_R");
// Right to edit vehicle lists
BoumRight.FLEET_VEHICLE_LIST_CRUD = new BoumRight(3151875125, 128, "FLEET_VEHICLE_LIST_CRUD");
// Right to add and remove vehicles to/from a vehicle list
BoumRight.FLEET_VEHICLE_LIST_CURATION_CRUD = new BoumRight(3151875126, 129, "FLEET_VEHICLE_LIST_CURATION_CRUD");
// Right to wipe box PCs
BoumRight.FLEET_VEHICLE_PROVISIONING_CRUD = new BoumRight(3151875127, 130, "FLEET_VEHICLE_PROVISIONING_CRUD");
// Right to read vehicles
BoumRight.FLEET_VEHICLE_R = new BoumRight(3151875128, 131, "FLEET_VEHICLE_R");
// Right to change a vehicle’s seat configuration
BoumRight.FLEET_VEHICLE_SEAT_CONFIGURATION_CRUD = new BoumRight(3151875129, 132, "FLEET_VEHICLE_SEAT_CONFIGURATION_CRUD");
// Right to send individual message
BoumRight.INDIVIDUAL_MESSAGE = new BoumRight(3151875132, 135, "INDIVIDUAL_MESSAGE");
// Right to create, read, update and delete records in the "Marketing Ads Manager Area"
BoumRight.MARKETING_ADS_MANAGER_CRUD = new BoumRight(3151875133, 136, "MARKETING_ADS_MANAGER_CRUD");
// Right to read records in the "Marketing Ads Manager Area"
BoumRight.MARKETING_ADS_MANAGER_R = new BoumRight(3151875134, 137, "MARKETING_ADS_MANAGER_R");
// Right to send mass messages
BoumRight.MASS_MESSAGE = new BoumRight(3151875135, 138, "MASS_MESSAGE");
// Access to "Mass Message option for Driver app update"
BoumRight.MASS_MESSAGE_RELEASE_NOTES = new BoumRight(3151875136, 139, "MASS_MESSAGE_RELEASE_NOTES");
// Currently not used in BOFE
BoumRight.PAYMENT_COUPON_BATCH_ACTIVATE = new BoumRight(3151875137, 140, "PAYMENT_COUPON_BATCH_ACTIVATE");
// Right to create coupons
BoumRight.PAYMENT_COUPON_BATCH_C = new BoumRight(3151875138, 141, "PAYMENT_COUPON_BATCH_C");
// Right to see coupons / access "Coupon Area"
BoumRight.PAYMENT_COUPON_BATCH_R = new BoumRight(3151875139, 142, "PAYMENT_COUPON_BATCH_R");
// Right to activate coupons
BoumRight.PAYMENT_COUPON_BATCH_U = new BoumRight(3151875140, 143, "PAYMENT_COUPON_BATCH_U");
// Right to see payment details for trips
BoumRight.PAYMENT_DETAILS_R = new BoumRight(3151875141, 144, "PAYMENT_DETAILS_R");
// Right to read payment packages eG smart saver
BoumRight.PAYMENT_PACKAGE_R = new BoumRight(3151875142, 145, "PAYMENT_PACKAGE_R");
// Right to update payment packages eG smart saver (trigger refunds)
BoumRight.PAYMENT_PACKAGE_U = new BoumRight(3151875143, 146, "PAYMENT_PACKAGE_U");
// Right to assign tipping
BoumRight.PAYMENT_TIPPING_ASSIGN = new BoumRight(3151875144, 147, "PAYMENT_TIPPING_ASSIGN");
// Right to payout tips
BoumRight.PAYMENT_TIPPING_PAYOUT = new BoumRight(3151875145, 148, "PAYMENT_TIPPING_PAYOUT");
// Right to read driver tippings
BoumRight.PAYMENT_TIPPING_R = new BoumRight(3151875146, 149, "PAYMENT_TIPPING_R");
// Right to approve pricing configs
BoumRight.PRICING_CONFIG_APPROVE = new BoumRight(3151875147, 150, "PRICING_CONFIG_APPROVE");
// Right to create/delete/edit pricing configs
BoumRight.PRICING_CONFIG_CRUD = new BoumRight(3151875148, 151, "PRICING_CONFIG_CRUD");
// Right to see pricing configs / access "Pricing Area"
BoumRight.PRICING_CONFIG_R = new BoumRight(3151875149, 152, "PRICING_CONFIG_R");
// Right to create polygons in pricing polygon library
BoumRight.PRICING_POLYGON_CRUD = new BoumRight(3151875150, 153, "PRICING_POLYGON_CRUD");
// Right to see polygons in pricing polygon library & access "Pricing Area"
BoumRight.PRICING_POLYGON_R = new BoumRight(3151875151, 154, "PRICING_POLYGON_R");
// Report IO, create new templates
BoumRight.REPORT_IO_TEMPLATE_ADMIN = new BoumRight(3151875174, 177, "REPORT_IO_TEMPLATE_ADMIN");
// Right to adjust area capacity limits
BoumRight.SERVICE_AREA_AREAS_CAPACITY_LIMITS = new BoumRight(3151875152, 155, "SERVICE_AREA_AREAS_CAPACITY_LIMITS");
// Right to edit the service areas
BoumRight.SERVICE_AREA_AREAS_CRUD = new BoumRight(3151875153, 156, "SERVICE_AREA_AREAS_CRUD");
// Right to read service areas
BoumRight.SERVICE_AREA_AREAS_R = new BoumRight(3151875154, 157, "SERVICE_AREA_AREAS_R");
// Right to edit Service Areas
BoumRight.SERVICE_AREA_CRUD = new BoumRight(3151875155, 158, "SERVICE_AREA_CRUD");
// Right to edit hubs
BoumRight.SERVICE_AREA_HUB_CRUD = new BoumRight(3151875156, 159, "SERVICE_AREA_HUB_CRUD");
// Right to read hubs
BoumRight.SERVICE_AREA_HUB_R = new BoumRight(3151875157, 160, "SERVICE_AREA_HUB_R");
// Right to read service areas
BoumRight.SERVICE_AREA_R = new BoumRight(3151875158, 161, "SERVICE_AREA_R");
// Right to edit the stop network
BoumRight.SERVICE_AREA_STOP_CRUD = new BoumRight(3151875159, 162, "SERVICE_AREA_STOP_CRUD");
// Right to read stop network
BoumRight.SERVICE_AREA_STOP_R = new BoumRight(3151875160, 163, "SERVICE_AREA_STOP_R");
// Right to create, read, update or delete stop network task notifications
BoumRight.SERVICE_AREA_STOP_TASK_CRUD = new BoumRight(3151875161, 164, "SERVICE_AREA_STOP_TASK_CRUD");
// Right to read stop network task notifications
BoumRight.SERVICE_AREA_STOP_TASK_R = new BoumRight(3151875162, 165, "SERVICE_AREA_STOP_TASK_R");
// Right to update Service Areas
BoumRight.SERVICE_AREA_U = new BoumRight(3151875163, 166, "SERVICE_AREA_U");
// Right to edit the service hours
BoumRight.SERVICE_HOUR_CRUD = new BoumRight(3151875164, 167, "SERVICE_HOUR_CRUD");
// Right to read service hours
BoumRight.SERVICE_HOUR_R = new BoumRight(3151875165, 168, "SERVICE_HOUR_R");
// Right to create, read, update and delete Service Packages
BoumRight.SERVICE_PACKAGE_CRUD = new BoumRight(3151875166, 169, "SERVICE_PACKAGE_CRUD");
// Right to read Service Packages
BoumRight.SERVICE_PACKAGE_R = new BoumRight(3151875167, 170, "SERVICE_PACKAGE_R");
// Right to create, read, update and delete Work Orders
BoumRight.WORK_ORDERS_CRUD = new BoumRight(3151875168, 171, "WORK_ORDERS_CRUD");
// Right to read Work Orders
BoumRight.WORK_ORDERS_R = new BoumRight(3151875169, 172, "WORK_ORDERS_R");
// This right enables a person to manage the CUGT participation of a rider.
BoumRight.CUGT_ALLOWLIST_CRUD = new BoumRight(3151875176, 179, "CUGT_ALLOWLIST_CRUD");
// Read employee name and role
BoumRight.EMPLOYEE_NAME_R = new BoumRight(3151875180, 183, "EMPLOYEE_NAME_R");
// Read employee contract data
BoumRight.EMPLOYEE_CONTRACT_R = new BoumRight(3151875181, 184, "EMPLOYEE_CONTRACT_R");
// Read employee contact data
BoumRight.EMPLOYEE_CONTACT_R = new BoumRight(3151875182, 185, "EMPLOYEE_CONTACT_R");
// Right to create stops in bulk
BoumRight.SERVICE_AREA_STOP_BULK_CRUD = new BoumRight(3151875183, 186, "SERVICE_AREA_STOP_BULK_CRUD");
// Cancel service for all in-field vehicles
BoumRight.FLEET_CONTROL_MASS_FLEET_SHUTDOWN = new BoumRight(3151875184, 187, "FLEET_CONTROL_MASS_FLEET_SHUTDOWN");
// Cancel a trip
BoumRight.FLEET_CONTROL_CANCEL_TRIP = new BoumRight(3151875185, 188, "FLEET_CONTROL_CANCEL_TRIP");
// Allows to confirm a manual no show on a trip
BoumRight.CONFIRM_MANUAL_NO_SHOW = new BoumRight(3151875186, 189, "CONFIRM_MANUAL_NO_SHOW");
// Allows to see employee sickness / absence
BoumRight.EMPLOYEE_ABSENCES_R = new BoumRight(3151875187, 190, "EMPLOYEE_ABSENCES_R");
// Allows operator manually check-in passenger
BoumRight.CONFIRM_PASSENGER_MANUAL_CHECK_IN = new BoumRight(3151875188, 191, "CONFIRM_PASSENGER_MANUAL_CHECK_IN");
// Allows users to read Fleet data in the AREA_FLEETS
BoumRight.AREA_FLEETS = new BoumRight(3151875189, 192, "AREA_FLEETS");
// Allows users to read Fleet data
BoumRight.FLEET_R = new BoumRight(3151875190, 193, "FLEET_R");
// Allows users to create, read, update, delete Fleets
BoumRight.FLEET_CRUD = new BoumRight(3151875191, 194, "FLEET_CRUD");
// Access to the Safety Driver Interface area
BoumRight.AREA_SAFETY_DRIVER_INTERFACE = new BoumRight(3151875192, 195, "AREA_SAFETY_DRIVER_INTERFACE");
// Access to the Offer and Pooling area
BoumRight.AREA_OFFER_AND_POOLING = new BoumRight(3151875193, 196, "AREA_OFFER_AND_POOLING");
// The permission will allow users to update the list of fleets an employee has access to
BoumRight.EMPLOYEE_FLEETS_U = new BoumRight(3151875194, 197, "EMPLOYEE_FLEETS_U");
// Allows users to read and manage hardware components
BoumRight.FLEET_VEHICLE_HARDWARE_CRUD = new BoumRight(3151875196, 199, "FLEET_VEHICLE_HARDWARE_CRUD");
// Right to read customers firstname and lastname, requires BACKOFFICE_CUSTOMER_R
BoumRight.BACKOFFICE_CUSTOMER_NAME_R = new BoumRight(3151875201, 204, "BACKOFFICE_CUSTOMER_NAME_R");
// Right to read customers email address, requires BACKOFFICE_CUSTOMER_R
BoumRight.BACKOFFICE_CUSTOMER_EMAIL_ADDRESS_R = new BoumRight(3151875202, 205, "BACKOFFICE_CUSTOMER_EMAIL_ADDRESS_R");
// Right to read customers phone number, requires BACKOFFICE_CUSTOMER_R
BoumRight.BACKOFFICE_CUSTOMER_PHONE_NUMBER_R = new BoumRight(3151875203, 206, "BACKOFFICE_CUSTOMER_PHONE_NUMBER_R");
// Right to read customers severely disabled state, requires BACKOFFICE_CUSTOMER_R
BoumRight.BACKOFFICE_CUSTOMER_SEVERELY_DISABLED_R = new BoumRight(3151875204, 207, "BACKOFFICE_CUSTOMER_SEVERELY_DISABLED_R");
// Right to conduct the cabin safety check for autonomous vehicles
BoumRight.SDG_CONDUCT_CABIN_SAFETY_CHECK = new BoumRight(3151875205, 208, "SDG_CONDUCT_CABIN_SAFETY_CHECK");
// Right to view the optimization detour parameters
BoumRight.OPTIMIZATION_DETOUR_PARAMETERS_R = new BoumRight(3151875206, 209, "OPTIMIZATION_DETOUR_PARAMETERS_R");
// Right to create/read/update/delete the optimization detour parameters
BoumRight.OPTIMIZATION_DETOUR_PARAMETERS_CRUD = new BoumRight(3151875207, 210, "OPTIMIZATION_DETOUR_PARAMETERS_CRUD");
// Create a coupon batch valid for any service area
BoumRight.COUPON_BATCH_CREATE_FOR_ALL_SERVICE_AREAS = new BoumRight(3151875208, 211, "COUPON_BATCH_CREATE_FOR_ALL_SERVICE_AREAS");
// Report IO Disruptions Read
BoumRight.REPORT_DISRUPTION_R = new BoumRight(3151875209, 212, "REPORT_DISRUPTION_R");
// Report IO Disruptions Create Read Update and Delete
BoumRight.REPORT_DISRUPTION_CRUD = new BoumRight(3151875210, 213, "REPORT_DISRUPTION_CRUD");
// Access to Report Disruption Area
BoumRight.REPORT_DISRUPTION_AREA = new BoumRight(3151875211, 214, "REPORT_DISRUPTION_AREA");
// Report IO Accidents Read
BoumRight.REPORT_ACCIDENT_R = new BoumRight(3151875212, 215, "REPORT_ACCIDENT_R");
// Report IO Accidents Create Read Update and Delete
BoumRight.REPORT_ACCIDENT_CRUD = new BoumRight(3151875213, 216, "REPORT_ACCIDENT_CRUD");
// Access to Report Accident Area
BoumRight.REPORT_ACCIDENT_AREA = new BoumRight(3151875214, 217, "REPORT_ACCIDENT_AREA");
// Report vehicle checks read
BoumRight.REPORT_VEHICLE_CHECK_R = new BoumRight(3151875215, 218, "REPORT_VEHICLE_CHECK_R");
// Report vehicle checks create, read, update, and delete
BoumRight.REPORT_VEHICLE_CHECK_CRUD = new BoumRight(3151875216, 219, "REPORT_VEHICLE_CHECK_CRUD");
// Report IO, create new templates
BoumRight.REPORT_TEMPLATE_ADMIN = new BoumRight(3151875217, 220, "REPORT_TEMPLATE_ADMIN");
// Is allowed to create static send-outs of reports via eMail from the Backoffice Dashboard Area.
BoumRight.SCM_REPORT_CREATION = new BoumRight(3151875218, 221, "SCM_REPORT_CREATION");
// Is allowed to create over-the-air updates for the maas-ecu with the artifact-deployment API
BoumRight.FLEET_VEHICLE_MAAS_OTA_CRUD = new BoumRight(3151875219, 222, "FLEET_VEHICLE_MAAS_OTA_CRUD");
// Is allowed to get the over-the-air update status for the maas-ecu with the artifact-deployment API
BoumRight.FLEET_VEHICLE_MAAS_OTA_R = new BoumRight(3151875220, 223, "FLEET_VEHICLE_MAAS_OTA_R");
// Establishes an exterior video stream through IVS
BoumRight.AD_FLEET_CONTROL_EXTERIOR_VIDEO_STREAM = new BoumRight(3151875221, 224, "AD_FLEET_CONTROL_EXTERIOR_VIDEO_STREAM");
// Right to create legal documents
BoumRight.BACKOFFICE_LEGAL_DOCUMENT_W = new BoumRight(3151875222, 225, "BACKOFFICE_LEGAL_DOCUMENT_W");
// Right to read legal documents
BoumRight.BACKOFFICE_LEGAL_DOCUMENT_R = new BoumRight(3151875223, 226, "BACKOFFICE_LEGAL_DOCUMENT_R");
// Allows users to see the FETCH tool area
BoumRight.AREA_FETCH = new BoumRight(3151875224, 227, "AREA_FETCH");
// Right to create, update, read Work Orders
BoumRight.WORK_ORDERS_CRU = new BoumRight(3151875225, 228, "WORK_ORDERS_CRU");
// Right to close Work Orders.
BoumRight.WORK_ORDERS_CLOSE = new BoumRight(3151875226, 229, "WORK_ORDERS_CLOSE");
// Manage app store assets for the mobile apps
BoumRight.AREA_MOBILE_APPSTORE_ASSETS = new BoumRight(3151875227, 230, "AREA_MOBILE_APPSTORE_ASSETS");
// Allows access to road network area
BoumRight.AREA_ROAD_NETWORK = new BoumRight(3151875228, 231, "AREA_ROAD_NETWORK");
// Allows users to view and edit road network entities
BoumRight.ROAD_NETWORK_CRUD = new BoumRight(3151875229, 232, "ROAD_NETWORK_CRUD");
// Allows users to view road network entities
BoumRight.ROAD_NETWORK_R = new BoumRight(3151875230, 233, "ROAD_NETWORK_R");
const byEnum = Object.values(BoumRight).reduce((acc, v) => { acc[v.value()] = v.str(); return acc; }, {});
class enDeCoder {
    constructor() {
        _enDeCoder_enums.set(this, Object.values(BoumRight).sort((a, b) => {
            if (a.str() < b.str())
                return -1;
            if (a.str() > b.str())
                return 1;
            return 0;
        }));
        _enDeCoder_values.set(this, Object.keys(BoumRight));
    }
    toEnum(s) {
        return BoumRight[s];
    }
    fromEnum(r) {
        return byEnum[(r === null || r === void 0 ? void 0 : r.value()) || -1];
    }
    toEnums(...s) {
        return this.toPermissions(...s).toEnums();
    }
    toPermissions(...s) {
        return claims_1.Permissions.FromString(exports.BoumRightEnDeCoder, ...s);
    }
    enums() {
        return __classPrivateFieldGet(this, _enDeCoder_enums, "f");
    }
    values() {
        return __classPrivateFieldGet(this, _enDeCoder_values, "f");
    }
    name() {
        return "BoumRight";
    }
}
_enDeCoder_enums = new WeakMap(), _enDeCoder_values = new WeakMap();
exports.BoumRightEnDeCoder = new enDeCoder();
//# sourceMappingURL=boum-right.js.map